import { action } from "satcheljs";

export interface NeedsReplyCountRefreshRequestedMessage {
    tableViewId: string;
    hasNewNREmail: boolean;
}

/**
 * Dispatched when inbox row notifications suggest the NeedsReply count may have changed.
 * The tableViewId can be either an inbox or NeedsReply view table — orchestrators resolve
 * the correct inbox context from it.
 */
export const needsReplyCountRefreshRequested: (tableViewId: string, hasNewNREmail?: boolean) => NeedsReplyCountRefreshRequestedMessage = action("needsReplyCountRefreshRequested", (tableViewId: string, hasNewNREmail = false): NeedsReplyCountRefreshRequestedMessage => ({
    tableViewId,
    hasNewNREmail,
}));
